import COLOUR_MAP from '../../Text/constants/colourMap';
import { Colour } from '../../Text/types';

import styles from './divider.module.scss';

export function Divider({ margin, height, color }: { margin?: number | string; height?: number; color?: Colour }) {
  const backgroundColor = color ? COLOUR_MAP[color] : void 0;

  return <div className={styles['divider']} style={{ margin, height, backgroundColor }} />;
}
